import { render, staticRenderFns } from "./Divisor.vue?vue&type=template&id=34af7cba&scoped=true&"
import script from "./Divisor.vue?vue&type=script&lang=js&"
export * from "./Divisor.vue?vue&type=script&lang=js&"
import style0 from "./Divisor.vue?vue&type=style&index=0&id=34af7cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af7cba",
  null
  
)

export default component.exports